var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAsianPopMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Love-Lollipop--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Love Lollipop Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6a0.5 0.5 0 0 1 -0.5 -0.5 5.5 5.5 0 0 0 -11 0V16a1 1 0 0 0 1 1h10.5a5.5 5.5 0 0 0 0 -11Zm0 8h-8a0.5 0.5 0 0 1 -0.5 -0.5v-8a2.5 2.5 0 0 1 5 0V8a1 1 0 0 0 1 1h2.5a2.5 2.5 0 0 1 0 5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23 17.35a0.5 0.5 0 0 0 -0.7 0L0.44 21.44a1.5 1.5 0 0 0 2.12 2.12l4.09 -4.09a0.5 0.5 0 0 0 0 -0.7Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAsianPopMusic);
export default ForwardRef;